const reasons = [
  {
    icon: 'ri-flashlight-fill',
    title: 'Hızlı Teslimat',
    desc: 'Siparişini aynı gün hazırlıyoruz. Mağazadan anında teslim seçeneği de var.',
    color: '#ffffff',
  },
  {
    icon: 'ri-medal-2-fill',
    title: 'Yüksek Baskı Kalitesi',
    desc: 'UV baskı teknolojisi ile solmayan, canlı renkler. Kalite garantimiz var.',
    color: '#ffffff',
  },
  {
    icon: 'ri-smartphone-fill',
    title: 'En Yeni Modeller',
    desc: 'iPhone 15, 16 serisi dahil tüm yeni modeller için kılıf stoğumuz her zaman hazır.',
    color: '#ffffff',
  },
  {
    icon: 'ri-message-2-fill',
    title: 'Anında WhatsApp Destek',
    desc: 'Soru, sipariş veya tasarım için 1 mesaj yeter. 7/24 yanınızdayız.',
    color: '#25D366',
  },
  {
    icon: 'ri-store-2-fill',
    title: 'Mağazadan Teslim',
    desc: 'Adana\'da mağazamıza gel, ürünleri bizzat gör ve anında teslim al.',
    color: '#ffffff',
  },
  {
    icon: 'ri-heart-fill',
    title: 'Müşteri Memnuniyeti',
    desc: '500\'den fazla mutlu müşteri. 5 yıldızlı deneyim her seferinde.',
    color: '#ffffff',
  },
];

export default function WhyUs() {
  return (
    <section id="neden-biz" className="py-20 md:py-28 bg-[#111111] relative overflow-hidden">
      {/* Decorative lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-14 md:mb-18">
          <p className="text-white/40 text-xs font-bold uppercase tracking-[0.3em] mb-3">Farkımız</p>
          <h2
            className="text-white uppercase leading-none mb-4"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(2.5rem, 7vw, 5rem)' }}
          >
            Neden <span className="text-[#FF4500]">Biz?</span>
          </h2>
          <p className="text-white/50 max-w-md mx-auto text-base">
            Rakiplerimizden bizi ayıran özelliklerimiz.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reasons.map((item, idx) => (
            <div
              key={idx}
              className="group bg-white/[0.03] hover:bg-white/[0.07] border border-white/8 hover:border-white/15 rounded-2xl p-6 transition-all duration-300 cursor-default"
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-5"
                style={{ background: `${item.color === '#ffffff' ? 'rgba(255,255,255,0.06)' : item.color + '20'}`, border: `1px solid ${item.color === '#ffffff' ? 'rgba(255,255,255,0.12)' : item.color + '30'}` }}
              >
                <i className={`${item.icon} text-xl`} style={{ color: item.color }} />
              </div>
              <h3 className="text-white font-bold text-base mb-2">{item.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="mt-14 md:mt-18 bg-gradient-to-r from-[#FF4500]/15 via-[#FF4500]/10 to-[#FF4500]/15 border border-[#FF4500]/20 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/20 pointer-events-none" />
          <div className="relative z-10">
            <p className="text-white/40 text-xs font-bold uppercase tracking-[0.3em] mb-3">Adana'nın En İyisi</p>
            <h3
              className="text-white uppercase mb-4"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(1.8rem, 4vw, 3rem)' }}
            >
              5+ Yıllık Tecrübe ile Hizmetinizdeyiz
            </h3>
            <p className="text-white/50 max-w-lg mx-auto text-sm md:text-base mb-8">
              Baraj Yolu'nda hizmet veren mağazamızda bizi ziyaret edin veya WhatsApp'tan bize ulaşın.
            </p>
            <a
              href="https://wa.me/903222286464"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#FF4500] hover:bg-[#e03d00] text-white px-8 py-4 rounded-full font-bold text-sm transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-[#FF4500]/25"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
              Hemen İletişime Geç
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
